import styled from "styled-components";

export const Wrapper = styled.div`
  && {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: ${(props) => props.theme.black50};
    flex-shrink: 0;
    min-width: 150px;
    row-gap: 4px;
    column-gap: 10px;

    ${(props) => props.theme.xs`
      flex-direction: row;
    `}
`;
